// extracted by css-extract-rspack-plugin
export default {"button":"button-IJ2yHO","value":"value-HqHe3N text-body-base","placeholder":"placeholder-EdphQ8"};